import { useRef } from 'react';

let counter = 0;
export function generateUniqueId(prefix?: string) {
  return `${prefix ? prefix : ''}${counter++}-${Date.now()}-${Math.round(Math.random() * 10000)}`;
}

export function useUniqueId(prefix?: string) {
  const { current: uniqueId } = useRef(generateUniqueId(prefix));
  return uniqueId;
}
